
import { useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/components/AuthProvider";
import { StudentAuthForm } from "@/components/auth/StudentAuthForm";
import { PasswordResetForm } from "@/components/auth/PasswordResetForm";
import { useLanguage } from "@/components/LanguageContext";
import { useLanguagePath } from "@/utils/language";

const StudentAuth = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [isPasswordReset, setIsPasswordReset] = useState(false);
  const { user, profile } = useAuth();
  const { t } = useLanguage();
  const { getPath } = useLanguagePath();

  if (user && profile) {
    if (!profile.is_onboarded) {
      return <Navigate to={getPath("/complete-profile")} replace />;
    }
    if (profile.is_student && !profile.is_trainer) {
      return <Navigate to={getPath("/student-dashboard")} replace />;
    } else if (profile.is_trainer && !profile.is_student) {
      return <Navigate to={getPath("/dashboard")} replace />;
    } else {
      return <Navigate to={getPath("/student-dashboard")} replace />;
    }
  }

  const handleBackToLogin = () => {
    setIsPasswordReset(false);
  };

  const handleForgotPassword = () => {
    setIsPasswordReset(true);
  };

  if (isPasswordReset) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-secondary/20 dark:from-gray-900 dark:to-gray-800/50 flex items-center justify-center p-4">
        <div className="w-full max-w-md space-y-8 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg">
          <PasswordResetForm onBackToLogin={handleBackToLogin} />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-secondary/20 dark:from-gray-900 dark:to-gray-800/50 flex items-center justify-center p-4">
      <div className="w-full max-w-md space-y-8 bg-white dark:bg-gray-800 p-8 rounded-lg shadow-lg">
        <StudentAuthForm 
          isLogin={isLogin}
          onForgotPassword={handleForgotPassword}
        />
        <div className="text-center">
          <button
            onClick={() => setIsLogin(!isLogin)}
            className="text-sm text-primary dark:text-white hover:underline"
          >
            {isLogin
              ? t('auth.student.login.noAccount')
              : t('auth.student.register.hasAccount')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentAuth;
